import React, { useState } from 'react';
import OTPInput from "otp-input-react";
import { useAuthContext } from "../../hooks/agencyAuthHook";
import { Link,useNavigate } from 'react-router-dom'
import bgimage from '../../assets/images/bgimage.jpg'
import toast from "react-hot-toast";
import { Dialog} from '@mui/material'
 
export default function OTPVerification() {
    const navigate = useNavigate()
  const apiUrl = process.env.REACT_APP_API_URL;
  const { dispatch } = useAuthContext();
  const [otp_code, setotp_code] = useState('')
  const email=sessionStorage.getItem('email');
   
  const [updatedEmail,setUpdatedEmail]=useState('')
 const [openNew, setOpenNew] = React.useState(false);
  const handleClickOpenNew = () => {
    setOpenNew(true);
  };

  const handleCloseNew = () => {
    setOpenNew(false);
    setUpdatedEmail('')
  }
    const[isLoading,setIsLoading]=useState(false)
    
  const getNewOTP = async (e) => {
    e.preventDefault()
    setIsLoading(true)
    toast.promise(
      new Promise(async (resolve, reject) => {
        try {
          const response = await fetch(`${apiUrl}/api/agencies/get_new_otp`, {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({email }),
          });

          const json = await response.json();

          if (response.ok) {
            resolve(json.message);
            sessionStorage.setItem("email", updatedEmail);
            setIsLoading(false)
            handleCloseNew()
          } else {
            reject(new Error(json.message)); // Use actual API message for error
            setIsLoading(false)

            
          }
        } catch (error) {
          reject(new Error(error.message)); // Handle unexpected errors
          setIsLoading(false)

        } finally {

        }
      }),
      {
        loading: "Processing...",
        success: (message) => <b>{message}</b>, // Use dynamic message for success
        error: (error) => <b>{error.message}</b>, // Use dynamic message for error
      }
    );
  }

  const verifyEmail = async (e) => {
    e.preventDefault()
    toast.promise(
      new Promise(async (resolve, reject) => {
        try {

          const response = await fetch(`${apiUrl}/api/agencies/email/verfication`, {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({email:email, otp_code }),
          });

          const json = await response.json();

          if (response.ok) {
            resolve(json.message);
            localStorage.setItem("agency", JSON.stringify(json));
            dispatch({ type: "AGENCY_LOGIN", payload: json });
            navigate('/profile')
            sessionStorage.removeItem("email");

          } else {
            reject(new Error(json.message)); // Use actual API message for error
          }
        } catch (error) {
          reject(new Error(error.message)); // Handle unexpected errors
        } finally {

        }
      }),
      {
        loading: "Verifying...",
        success: (message) => <b>{message}</b>, // Use dynamic message for success
        error: (error) => <b>{error.message}</b>, // Use dynamic message for error
      }
    );
  }

  return (
    <div className='container-fluid bg-white signup_form '>
    <div className="row px-0 ">
         <div className="col-md-6 col-lg-4 d-lg-block d-none p-0">
                  <div className="bg_image">
                    <img src={bgimage} className='p-0' alt="" />

                  </div>
                  </div>

                    <div className="col-md-10 col-lg-4 px-md-1 px-xl-4 px-2 my-auto mx-auto p-0">           
                              <form onSubmit={verifyEmail}>
                                <div className="mb-1">
                                  <h1>Enter OTP</h1>
                                  <p>OTP sent to <Link>{updatedEmail?updatedEmail:email}</Link>. <Link className='edit_btn border px-1 rounded' onClick={()=>handleClickOpenNew()}>Edit Email</Link></p>
                                </div>
                                <div className="row">
                                  <div className="col-md-12">
                                    <OTPInput
                                      required
                                      value={otp_code}
                                      onChange={setotp_code} // This updates the otpCode state
                                      autoFocus
                                      OTPLength={6} // Set the length of the OTP
                                      otpType="number" // Specify the type of OTP
                                      inputStyles={{
                                        width: "100%",
                                        height: "45px",
                                        paddingLeft: '6px',
                                        margin: "5px",
                                        textAlign: "center",
                                        fontSize: "18px",
                                        borderRadius: "4px",
                                        border: "1px solid #ccc",
                                        background: 'white',
                                        color: 'black'
                                      }}
                                    />
                                    
                                  </div>
                                </div>
                                <button type="submit" className="btn submit_btn w-100 mt-4">Verify OTP</button>
                              </form>
                            
                  
                          </div>
        
               
    </div>

    <Dialog className='p-0'
        open={openNew}
        keepMounted
        aria-describedby="alert-dialog-slide-description"
      >
        <div className="container-fluid">
          <div className="row ">
            <div className="col-md-12 px-0 m-0">
              <form onSubmit={getNewOTP}>
                <div className="card add_new_modal px-2">
                  <div className="card-header bg-white">
                  Update email to get OTP
                    
                  </div>
                  <div className="card-body pt-0">
                    <div className="row  py-2">
                     
                      <div className={`data my-1  px-1 col-md-12`}>
                        <label htmlFor="" >Email Address</label>
                        <input type="email" value={updatedEmail} placeholder="Email here" onChange={(e) => setUpdatedEmail(e.target.value)} className='mt-1' id="" required />
                      </div>

                      <hr />
                      <div className="text-end mt-1 pb-0">
                        <button className="btn cancel_btn mx-2  py-2" type='button' onClick={() => handleCloseNew()} disabled={isLoading}>Cancel</button>
                        <button className="btn save_btn mx-2 " type='submit' disabled={isLoading}>Get OTP</button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </Dialog>


    </div>
  )
}
